import {FC} from 'react';

import {useTranslation} from 'react-i18next';

import {
  ProductCornerQuantityOverlay,
  ProductQuantityOverlay,
  ProductThumbnailImage,
  ProductThumbnailImageOverlay,
  QuantityText
} from './styles';
import {ProductWithQuantity} from './types';

export interface ProductThumbnailProps {
  product: ProductWithQuantity;
  isMoreProductsAvailable: boolean;
  leftQuantity: number;
}

export const ProductThumbnail: FC<ProductThumbnailProps> = (props) => {
  const {product, isMoreProductsAvailable, leftQuantity} = props;

  const {t} = useTranslation();

  const productQuantity = product.isWeightedFresh
    ? t('estimatedItemWeightWithoutDot', {weight: +(product.quantity * product.moq)?.toFixed(2)})
    : product.quantity;

  return (
    <ProductThumbnailImage imageURl={product.imageURl}>
      {isMoreProductsAvailable ? (
        <>
          <ProductThumbnailImageOverlay />
          <ProductQuantityOverlay>
            <QuantityText>+ {leftQuantity}</QuantityText>
          </ProductQuantityOverlay>
        </>
      ) : (
        <>
          <ProductCornerQuantityOverlay>
            <QuantityText id={`${product.title}_total_order`}>{productQuantity}</QuantityText>
          </ProductCornerQuantityOverlay>
        </>
      )}
    </ProductThumbnailImage>
  );
};

ProductThumbnail.displayName = 'ProductThumbnail';
